// extracted by mini-css-extract-plugin
export default {"ac_claim":"index-module--ac_claim--zapje"};